import {Component, OnDestroy, OnInit} from '@angular/core';
import {Network} from '@ionic-native/network/ngx';
import {ToastController} from '@ionic/angular';
import {NetworkStatus} from '../../../config';

@Component({
    selector: 'app-network-status',
    templateUrl: './network-status.component.html',
    styleUrls: ['./network-status.component.scss'],
})
export class NetworkStatusComponent implements OnInit, OnDestroy {
    connectSubscription;
    disconnectSubscription;
    networkState;

    constructor(
        private network: Network,
        private toastController: ToastController
    ) {
        this.watchNetwork();
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.disconnectSubscription.unsubscribe();
        this.connectSubscription.unsubscribe();
    }

    watchNetwork() {
        window.addEventListener('online', e => {
            NetworkStatus.status = 'online';
            this.showStatus('network listener connected');
        }, false);
        window.addEventListener('offline', e => {
            NetworkStatus.status = 'offline';
            this.showStatus('network listener disconnected');
        }, false);
        // watch network for a disconnection
        this.disconnectSubscription = this.network.onDisconnect().subscribe(() => {
            NetworkStatus.status = 'offline';
            this.showStatus('network subscribe disconnected');
        });
        this.connectSubscription = this.network.onConnect().subscribe(() => {
            NetworkStatus.status = 'online';
            this.showStatus('network subscribe connected');
        });
    }

    showStatus(status) {
        console.log(status);
        // const toast = await this.toastController.create({
        //     message: status,
        //     position: 'top',
        //     color: 'dark',
        //     duration: 2000
        // });
        // return await toast.present();
    }
}
